import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-537998b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question__descriptive" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIEditor = _resolveComponent("TUIEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TUIEditor, {
      key: _ctx.TUIEditorKey,
      modelValue: _ctx.answer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.answer) = $event)),
      disabled: (!_ctx.isAbleToRedoQuestions && _ctx.question.status.attempts)|| (_ctx.question.attemptLimit != null && _ctx.question.attemptLimit <= _ctx.question.status.attempts)
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
      disabled: (!_ctx.isAbleToRedoQuestions && _ctx.question.status.attempts) || (_ctx.question.attemptLimit != null && _ctx.question.attemptLimit <= _ctx.question.status.attempts)
    }, "Enviar resposta", 8, _hoisted_2)
  ]))
}